import React from 'react'
import Button from 'components/Button'
import { View } from 'components/View'
import { PlusIcon } from 'components/Icon/icons/plus'

export default function PlusButton ({
  onClick,
  width
}) {
  return (
    <Button
      style={{
        width: 'unset',
        height: 'unset',
        maxWidth: 'unset'
      }}
      onClick={onClick}
    >
      <View
        w={width || '98px'}
        centered
        py='9.5px'
        bgc='#ffffff'
        style={{
          borderRadius: '6px',
          border: '1px solid #DDDDDD'
        }}
      >
        <PlusIcon
          fill='#7F8D94'
          style={{
            width: '12px',
            height: '12px'
          }}
        />
      </View>
    </Button>
  )
}
